import React, { useEffect, useState } from 'react';

import { ResponsiveContainer, Cell, PieChart, Pie } from 'recharts';

export default function Arc({ percentage = 0, status = 'success' }) {
  return GaugeChart({ percentage: Math.abs(percentage), status });
}

const GaugeChart = ({ percentage, status }) => {
  let progressSize = 50;
  let backgroundSize = 50;

  const [slices, setSlices] = useState([
    {
      value: progressSize,
      color: '#2DB96D',
    },
    {
      value: backgroundSize,
      color: '#B3E6CB',
    },
  ]);

  const successColorBar = '#2DB96D';
  const successColorBackground = '#B3E6CB';
  const warningColorBar = '#E5854F';
  const warningColorBackground = '#F6D3C0';

  useEffect(() => {
    // based on the percentage, calculate the size of the progress and background slices
    progressSize = percentage * 100;
    backgroundSize = 100 - progressSize;

    setSlices([
      {
        value: progressSize,
        color: status === 'success' ? successColorBar : warningColorBar,
      },
      {
        value: backgroundSize,
        color:
          status === 'success'
            ? successColorBackground
            : warningColorBackground,
      },
    ]);
  }, [percentage, status]);

  const width = 100;
  const height = 60;

  const pieProps = {
    startAngle: 180,
    endAngle: 0,
    cx: width / 2,
    cy: width / 2,
    isAnimationActive: false,
  };

  return (
    <div style={{ width, height }}>
      <ResponsiveContainer>
        <PieChart width={width} height={height}>
          <Pie
            stroke="none"
            data={slices}
            innerRadius={(width / 2) * 0.6}
            outerRadius={(width / 2) * 0.9}
            dataKey="value"
            {...pieProps}
          >
            {slices.map((each, i) => (
              <Cell key={`cell-${i}`} fill={slices[i].color} stroke="none" />
            ))}
          </Pie>
          <Pie
            stroke="none"
            fill="none"
            activeIndex={1}
            innerRadius={(width / 2) * 0.5}
            outerRadius={(width / 2) * 0.6}
            {...pieProps}
          ></Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
